/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum PackageStatusType {
  REQUESTED = "REQUESTED",
  REQUEST_REJECTED = "REQUEST_REJECTED",
  CANCELLED = "CANCELLED",
  SCHEDULED = "SCHEDULED",
  IN_PROGRESS = "IN_PROGRESS",
  TRANSIT_START = "TRANSIT_START",
  TRANSIT_END = "TRANSIT_END",
  LOST = "LOST",
  UNAVAILABLE = "UNAVAILABLE",
  RETURN_TO_ORIGIN = "RETURN_TO_ORIGIN",
  RETURNED_TO_ORIGIN = "RETURNED_TO_ORIGIN",
  DELIVERED = "DELIVERED"
}

